import React from 'react';
import get from 'lodash/get';

export const defaultOptionRenderer = labelKey => option =>
  labelKey ? <div>{get(option, labelKey)}</div> : <div>{option}</div>;
